import React from 'react';

import Container from 'components/Container';

const Footer = () => {
  return (
    <footer>
      <Container>
        <p>Add a donut to the map</p>
      </Container>
    </footer>
  );
};

export default Footer;
